//#region src/core/i18n/text/volume.ts
const prefix = "volume.";
const mutedValueText = {
	key: `${prefix}mutedValue`,
	text: "{percent}, muted"
};
const mutedText = {
	key: `${prefix}muted`,
	text: "Muted"
};
const labelText = {
	key: `${prefix}label`,
	text: "Volume"
};
const valueText = {
	key: `${prefix}value`,
	text: "Volume {value}"
};
//#endregion
export { labelText, mutedText, mutedValueText, valueText };

//# sourceMappingURL=volume.js.map